<template>
  <div class="homecontainer _homecontainer">
    <NavTop :navid = id />
    <div class="home_box">
  <van-swipe style="height:30vh;" ref="home_banner" :autoplay="videoplay" indicator-color="#007aff" @change="onChange">
  <van-swipe-item v-for="(image, index) in images" :key="index" style="positoin:relative;">
      <img :src="image.image" v-if="image.type == 0" mode="aspectFit" style="width:100vw;height:30vh;"/>
<!-- <video id="bannervideo" :src="image.image"  @ended="videoover" v-else autoplay muted controls style="width:100%;height:100%;object-fit: cover;"></video> -->
    <div class="hometop_text2" :class="{hometop_animation2:bannerid == index}">{{image.title2}}</div>
       <div class="hometop_text" :class="{hometop_animation:bannerid == index}">{{image.title}}</div>
          <div class="hometop_text3" :class="{hometop_animation3:bannerid == index}">{{image.title3}}</div>
  </van-swipe-item>
</van-swipe>
     <!-- 关于我们 -->
     <div class="home_content">
       <div class="building_title">关于我们</div>
       <div class="home_li" v-for="me in contactmelist" :key="me.id" v-lazy:background-image="me.image" style="background-size:cover;" @click="contactmeto(me.id,me.title,me.thumbnail,me.post_id)">
         <div class="home_position">
           <div class="home_title">{{me.title}}</div>
           <div class="home_text">{{me.description}}</div>
         </div>
       </div>
     </div>
      <div class="home_content">
       <div class="building_title">两大前瞻战略</div>
         <div class="home_li" v-for="me in contactmelist1" :key="me.id" v-lazy:background-image="me.cover" style="background-size:cover;" @click="contactmeto(me.id,me.title,me.thumbnail,me.post_id)">
         <div class="home_position">
           <div class="home_title" style="width:62%;">{{me.title}}</div>
           <div class="home_text">{{me.description}}</div>
         </div>
       </div>
     </div>
     <!-- 五大发展领域 -->
     <div class="lingyu_box">
      <div class="lingyu_title">五大发展领域</div>
      <div class="lineyu_content">
        <div class="lingyu_li" v-for="home in homelist" :key="home.id" v-lazy:background-image="home.image" style="background-size:100% 100%;" @click="lineyuto(home.id,home.post_id,home.title,home.thumbnail)"></div>
      </div>
     </div>
      <!-- 新闻动态 -->
     <div class="building_box">
        <div class="building_title">聚利和新闻</div>
        <div class="building_li" v-for="item in articlelist" :key="item.id" @click="articleto(item.id,item.thumbnail)">
         <img v-lazy="item.image" mode="aspectFit" alt="">
         <div class="building_right">
           <div class="building_p">{{item.post_title}}</div>
           <div class="building_text">{{item.post_excerpt}}</div>
         </div>
        </div>
     </div>
    </div>
  </div>
</template>

<script>
import NavTop from '../comcomponents/NavTop'
import { Button, Swipe, SwipeItem } from 'vant'
import {getbannerlist, gethomemsg} from '../../api/jslihe'
export default {
  name: '',
  components: {
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    NavTop
  },
  data () {
    return {
      images: [],
      bannerid: '',
      contactmelist: [],
      contactmelist1: [],
      homelist: [],
      articlelist: [],
      videoplay: 5000,
      id: Number(this.$route.query.id) || 25
    }
  },
  mounted () {
    this.getbannerall()
    // this.getcontactmelist()
    this.gethomelist()
  },
  methods: {
    videoover () {
      setTimeout(() => {
        this.videoplay = 5000
        this.$refs.home_banner.next()
      }, 1500)
    },
    lineyuto (id, articleid, name, img) {
      this.$router.push({path: 'mac', query: {id: id, articleid: articleid, name: name, img: img}})
    },
    articleto (id, img) {
      this.$router.push({path: 'article', query: {id: id, img: img}})
    },
    contactmeto (id, name, img, articleid) {
      if (id === 22) {
        // 企业荣誉
        this.$router.push({path: 'iphone', query: {id: id}})
      } else if (id === 24) {
        // 团队风采 企业新闻  健康实训
        this.$router.push({path: 'ipad', query: {id: id, name: name, img: img}})
      } else if (id === 27 || id === 21 || id === 23 || id === 5 || id === 2 || id === 3) {
        // 文章页
        this.$router.push({path: 'mac', query: {id: id, articleid: articleid, name: name, img: img}})
      } else {
        return false
      }
    },
    getbannerall () {
      getbannerlist().then(res => {
        this.images = res.data[0].items
        this.images.shift()
      })
    },
    // getcontactmelist () {
    //   contactmeall({category_id: 20}).then(res => {
    //     console.log(res)
    //     this.contactmelist = res.data.categories
    //   })
    // },
    gethomelist () {
      gethomemsg().then(res => {
        console.log(res)
        this.contactmelist = res.data.info.slice(0, 2)
        this.contactmelist1 = res.data.info.slice(3, 5)
        this.homelist = res.data.info.slice(5, 10)
        this.articlelist = res.data.app_article
      })
    },
    onChange (e) {
      // console.log(e)
      // var myvideo = document.getElementById('bannervideo')
      // if (e === 0) {
      //   this.videoplay = 20000
      //   myvideo.currentTime = 0
      //   myvideo.play()
      // } else {
      //   this.videoplay = 5000
      //   myvideo.pause()
      // }
      this.bannerid = e
    }
  }
}
</script>

<style lang="less" scoped>
 .building_title{
         text-align: center;
         font-size:1.2rem;
         color:#333;
         font-weight: bold;
         padding-top:2vh;
         padding-bottom: 2vh;
       }
    .homecontainer{
      font-size: 1vw;
      .hometop_text{
        text-shadow: 0px 0px 7px #000;
        letter-spacing: 1px;
        text-align: center;
        color:#fff;
        font-size:0.9rem;
        font-weight: bold;
        position: absolute;
        left:0px;
        top:50%;
        transform: translate(0, -50%);
        width:100%;
      }
       .hometop_text2{
        text-shadow: 0px 0px 7px #000;
        letter-spacing: 1px;
        text-align: center;
        color:#fff;
        font-size:0.9rem;
        font-weight: bold;
        position: absolute;
        left:0px;
        top:37%;
        transform: translate(0, -50%);
        width:100%;
      }
       .hometop_text3{
        text-shadow: 0px 0px 7px #000;
        letter-spacing: 1px;
        text-align: center;
        color:#fff;
        font-size:0.9rem;
        font-weight: bold;
        position: absolute;
        left:0px;
        top:63%;
        transform: translate(0, -50%);
        width:100%;
      }
      .hometop_animation{
animation:homeout 1s 1 linear;
      }
       .hometop_animation2{
animation:homeout2 1s 1 linear;
      }
       .hometop_animation3{
animation:homeout3 1s 1 linear;
      }
       @keyframes homeout{
           0%{
             top:0%;
             opacity: 0.4;
             font-size: 0.6rem;
             transform: translate(0, -0%)
           }
           100%{
             top:52%;
             opacity: 1;
             font-size: 0.9rem;
             transform: translate(0, -50%);
           }
        }
        @keyframes homeout2{
           0%{
             top:0%;
             opacity: 0.4;
             font-size: 0.6rem;
             transform: translate(0, -0%)
           }
           100%{
             top:37%;
             opacity: 1;
             font-size: 0.9rem;
             transform: translate(0, -50%);
           }
        }
        @keyframes homeout3{
           0%{
             top:0%;
             opacity: 0.4;
             font-size: 0.6rem;
             transform: translate(0, -0%)
           }
           100%{
             top:63%;
             opacity: 1;
             font-size: 0.9rem;
             transform: translate(0, -50%);
           }
        }
      .lingyu_box{
        padding-top:2vh;
        padding-bottom:2vh;
        background: url('/static/img/lingyu.jpg') no-repeat;
        background-size: cover;
        .lingyu_title{
         text-align: center;
    font-size: 1.2rem;
    color: #333;
    font-weight: bold;
    padding-top: 2vh;
    padding-bottom: 2vh;
        }
        .lineyu_content{
          width:96%;
          margin-left: 2%;
          overflow: hidden;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .lingyu_li{
            width:31%;
            height:13vh;
            margin:1%;
          }
          .lingyu_li:first-child{
            margin-left:18%;
          }
        }
      }
      .building_box{
        padding-bottom:5vh;
        padding-left:0.5rem;
        padding-right:0.5rem;
       .building_li{
         margin-bottom:1rem;
         width:100%;
         display: flex;
         img{
           width:35%;
           height: 6rem;
           margin-right:5%;
           border-radius: 1vw;
         }
         .building_right{
           display: flex;
    flex-flow: column;
    justify-content: space-between;
    width:60%;
     .building_p{
       text-align:left;
           font-size:0.9rem;
           color:#333;
            white-space: nowrap;
  overflow: hidden;
  text-overflow:ellipsis;
  font-weight: bold;
         }
         .building_text{
           text-align:left;
           font-size:0.7rem;
           color:#666666;
 display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
/* autoprefixer: ignore next */
-webkit-box-orient: vertical;
         }
         }
       }
      }
      .home_content{
    .home_li{
      width:100vw;
      height:30vh;
      position:relative;
      .home_position{
      position: absolute;
      left:0px;
      bottom:0px;
      width:100%;
      height:40px;
      line-height: 40px;
      background:rgba(0,0,0,0.7);
      display: flex;
      .home_title{
        color:#fff;
        font-size:1rem;
        font-weight: bold;
        width:30%;
        margin-right:5%;
      }
      .home_text{
        color:#02A7F0;
        font-size:0.7rem;
        width:60%;
        margin-right: 5%;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
      }
      }
    }
  }
      // .subdiv{
      //   width: 100%;
      //   display: flex;
      //   justify-content: space-around;
      //   font-size: .5em;
      //   .left{
      //     width: 48%;
      //     height: 100%;
      //     font-size: .8em;
      //   }
      //   .right{
      //     width: 48%;
      //     height: 100%;
      //     font-size: .8em;
      //   }
      // }
    }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue